module.exports = __webpack_public_path__ + "static/media/blogGreen.a402dd06.svg";